var map = {
	"./check-mark.svg": "./src/assets/icons/check-mark.svg",
	"./deposit.svg": "./src/assets/icons/deposit.svg",
	"./egwi.svg": "./src/assets/icons/egwi.svg",
	"./extraPayment.svg": "./src/assets/icons/extraPayment.svg",
	"./inventory.svg": "./src/assets/icons/inventory.svg",
	"./leaving.svg": "./src/assets/icons/leaving.svg",
	"./picture.svg": "./src/assets/icons/picture.svg",
	"./rent.svg": "./src/assets/icons/rent.svg",
	"./staying.svg": "./src/assets/icons/staying.svg",
	"./studentTax.svg": "./src/assets/icons/studentTax.svg",
	"./undecided.svg": "./src/assets/icons/undecided.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*\\.svg$";